import { AlertTriangle, CheckCircle2, Database, LoaderCircle } from "lucide-react";
import type { DataLoadStatus } from "../types";

export default function DataStatusStrip({ status }: { status: DataLoadStatus }) {
  const icon = status.state === "loading"
    ? <LoaderCircle size={16} className="spin" />
    : status.state === "ready"
      ? <CheckCircle2 size={16} />
      : status.state === "partial" || status.state === "error"
        ? <AlertTriangle size={16} />
        : <Database size={16} />;
  const label = status.state === "loading"
    ? "공식 데이터 수집 중"
    : status.state === "ready"
      ? "공식 데이터 정상"
      : status.state === "partial"
        ? "일부 공식 데이터 N/A/STALE"
        : status.state === "error"
          ? "공식 데이터 수집 실패"
          : "데이터 대기";

  return (
    <div className={`data-status data-status--${status.state}`}>
      <span className="data-status__main">{icon}<strong>{label}</strong></span>
      <span>{status.loadedSeries}/{status.expectedSeries || "-"} 계열</span>
      <span>수집 {status.collectedAt ? new Date(status.collectedAt).toLocaleString("ko-KR") : "N/A"}</span>
      {status.issues.length > 0 && <a className="data-status__issues" href="#sources">이슈 {status.issues.length}건 보기</a>}
    </div>
  );
}
